import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { CartComponent } from './cart/cart.component';
import { CheckHost } from './Common/check-host';
import { CheckUserLogin } from './Common/check-user-login';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CreateWebinarComponent } from './create-webinar/create-webinar.component';
import { FaqsComponent } from './faqs/faqs.component';
import { HostSignUpComponent } from './host-sign-up/host-sign-up.component';
import { RewatchWebinarComponent } from './rewatch-webinar/rewatch-webinar.component';
import { HostDashboardComponent } from './HostPort/host-dashboard/host-dashboard.component';
import { MyStatsComponent } from './HostPort/my-stats/my-stats.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { LoginComponent } from './login/login.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PoliciesComponent } from './policies/policies.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { ProductsComponent } from './products/products.component';
import { PurchaseSeatsComponent } from './purchase-seats/purchase-seats.component';
import { RegisterComponent } from './register/register.component';
import { TermConditionsComponent } from './term-conditions/term-conditions.component';
import { PaymentPolicyComponent } from './payment-policy/payment-policy.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { DisputePolicyComponent } from './dispute-policy/dispute-policy.component';
import { HostingTermsComponent } from './hosting-terms/hosting-terms.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { WebinarRoomsComponent } from './webinar-rooms/webinar-rooms.component';
import { WebinarRunComponent } from './webinar-run/Dashboard/webinar-run.component';
import { WebinarRunDemoComponent } from './webinar-run/demo/webinar-run-demo.component';

import { WebinarComponent } from './webinar/webinar.component';
import { WebinarsComponent } from './webinars/webinars.component';
import { InterestedHostApprovalComponent } from './interested-host-approval/interested-host-approval.component';
import { FflImagesComponent } from './ffl-images/ffl-images.component';
import { OwnersPortalComponent } from './owners-portal/owners-portal.component';
import { CheckOwner } from './Common/check-owner';
import { VeemPaymentComponent } from './payments/veem-payment/veem-payment.component';
import { EmailVerificationComponent } from './verification/email-verification/email-verification.component';

const routes: Routes = [
  { path: '', redirectTo: 'Webinar-rooms', pathMatch: 'full' }, 
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      { path: '', component: LoginComponent },
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'Webinar-rooms', component: WebinarRoomsComponent },
      { path: 'Webinars/:id', component: WebinarsComponent, data: { shouldReuse: true } },
      { path: 'Products', component: ProductsComponent },
      { path: 'Cart', component: CartComponent, canActivate: [CheckUserLogin] },
      { path: 'create-webinar', component: CreateWebinarComponent, canActivate: [CheckUserLogin] },
      { path: 'edit-webinar/:id', component: CreateWebinarComponent, canActivate: [CheckUserLogin] },
      { path: 'faqs', component: FaqsComponent },
      { path: 'Policies', component: PoliciesComponent },
      { path: 'RefundPolicy', component: RefundPolicyComponent },
      { path: 'PaymentPolicy', component: PaymentPolicyComponent },
      { path: 'ShippingPolicy', component: ShippingPolicyComponent },
      { path: 'DisputePolicy', component: DisputePolicyComponent },
      { path: 'HostingTerms', component: HostingTermsComponent },
      { path: 'HowItWorks', component: HowItWorksComponent },
      { path: 'TermConditions', component: TermConditionsComponent },
      { path: 'Contact', component: ContactUsComponent },
      { path: 'contactus', redirectTo: 'Contact', pathMatch: 'full' },
      { path: 'ContactUs', redirectTo: 'Contact', pathMatch: 'full' },
      { path: 'Register', component: RegisterComponent },
      { path: 'Webinar/:id', component: WebinarComponent },
      { path: 'AboutUs', component: AboutUsComponent },
      { path: 'MyAccount', component: MyAccountComponent },
      { path: 'MyAccount/:isTab', component: MyAccountComponent },
      { path: 'SignUpHost', component: HostSignUpComponent, canActivate: [CheckUserLogin] },
      { path: 'HostPortal', component: HostDashboardComponent, canActivate: [CheckHost] },
      { path: 'MyStats', component: MyStatsComponent, canActivate: [CheckUserLogin] },
      { path: 'run-demo', component: WebinarRunDemoComponent },
      { path: 'run/:webinarguid', component: WebinarRunComponent, canActivate: [CheckUserLogin] },
      { path: 'RewatchWebinar/:webinarId', component: RewatchWebinarComponent, canActivate: [CheckUserLogin] },
      { path: 'HostPortal', component: HostDashboardComponent, canActivate: [CheckUserLogin] },
      { path: 'OwnerPortal', component:  OwnersPortalComponent, canActivate: [CheckOwner] },
      { path: 'fflImages', component:  FflImagesComponent  , canActivate: [CheckOwner]  },
      { path: 'Seat-Purchase/:id', component: PurchaseSeatsComponent, canActivate: [CheckUserLogin] },
      { path: 'veem-payment', component: VeemPaymentComponent},
      { path: 'VerifyEmail', component: EmailVerificationComponent}
    ]
  },
  // Redirect to Webinar-rooms if no path is provided
  { path: '**', redirectTo: '' } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
